module.exports = __webpack_public_path__ + "img/hand_sideleft_44.6f267ad4.svg";